import { Component, Output, EventEmitter, Input } from '@angular/core';
import { QRInput } from 'src/app/models/qr-input.model';

type InputTypes = string | number | undefined;

@Component({
  selector: 'app-dialog-example',
  templateUrl: './dialog-example.component.html',
  styleUrls: ['./dialog-example.component.scss'],
})
export class DialogExampleComponent {
  @Input() value: any;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  inputString: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre',
  };

  inputChange(value: InputTypes): void {
    if (value) {
      this.change.emit(value);
    }
  }
}
